// Shared championships list used by AddWrestler and EditShow
export const CHAMPIONSHIPS = [
  {
    name: 'Nessuno',
    value: '',
    image: '',
    type: 'none'
  },
  // --- WWE ---
  {
    name: 'WWE Champion',
    value: 'WWE Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwwe.png?alt=media&token=e56e2008-7899-4141-b4f0-a1946f7bddcc',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'World Heavyweight Champion',
    value: 'World Heavyweight Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwhw.png?alt=media&token=6dd69f69-fdf7-4c6d-a536-cfa7af851fe9',
    type: 'singles',
    gender: 'male'
  },
  {
    name: "WWE Women's Champion",
    value: "WWE Women's Champion",
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwwewms.png?alt=media&token=899c47bc-bf8a-4fb9-adb3-c2a06d3a9f68',
    type: 'singles',
    gender: 'female'
  },
  {
    name: "Women's World Champion",
    value: "Women's World Champion",
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwhwwms.png?alt=media&token=70f300b9-f386-46f9-8ed3-1f1a413f300d',
    type: 'singles',
    gender: 'female'
  },
  {
    name: 'United States Champion',
    value: 'United States Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fus.png?alt=media&token=0dde337c-10b3-4f3e-a839-732e4c405e07',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'Intercontinental Champion',
    value: 'Intercontinental Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fic.png?alt=media&token=ae2186e6-9318-4556-9651-df5d995ff731',
    type: 'singles',
    gender: 'male'
  },
  {
    name: "Women's United States Champion",
    value: "Women's United States Champion",
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fuswms.png?alt=media&token=3ce8ddaa-8e7f-4d20-9522-1b94b9663910',
    type: 'singles',
    gender: 'female'
  },
  {
    name: "Women's Intercontinental Champion",
    value: "Women's Intercontinental Champion",
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ficwms.png?alt=media&token=8dbd993a-be2a-44d5-bc3b-492752e7273d',
    type: 'singles',
    gender: 'female'
  },
  {
    name: 'World Tag Team Champion',
    value: 'World Tag Team Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwtag.png?alt=media&token=86d7b2bc-b87b-48c6-bd26-0f2902475df3',
    type: 'tag_team',
    gender: 'male'
  },
  {
    name: 'WWE Tag Team Champion',
    value: 'WWE Tag Team Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwwetag.png?alt=media&token=ca2fc4fc-e34f-40da-81c2-d619a83860e4',
    type: 'tag_team',
    gender: 'male'
  },
  {
    name: "Women's Tag Team Champion",
    value: "Women's Tag Team Champion",
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fwmstag.png?alt=media&token=bd4e9764-5008-43bc-90c0-6cb3d9c53225',
    type: 'tag_team',
    gender: 'female'
  },
  // --- NXT ---
  {
    name: 'NXT Champion',
    value: 'NXT Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fnxt.png?alt=media&token=4e7d44a8-f397-43e6-bec3-de9f3b54b0a7',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'NXT Women\'s Champion',
    value: 'NXT Women\'s Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fnxt-wom.png?alt=media&token=afd340a1-b086-4650-9130-9456a4f02437',
    type: 'singles',
    gender: 'female'
  },
  {
    name: 'NXT North American Champion',
    value: 'NXT North American Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fnxt-na.png?alt=media&token=5e7c0bbc-474d-4ded-8301-c3c019b8b281',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'NXT Women\'s North American Champion',
    value: 'NXT Women\'s North American Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fnxt-wom-na.png?alt=media&token=29bc1261-4616-4086-8f5f-03558427cbfb',
    type: 'singles',
    gender: 'female'
  },
  {
    name: 'NXT Tag Team Champion',
    value: 'NXT Tag Team Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fnxt-tag.png?alt=media&token=4990c5be-3870-4a3f-b312-5c825cad06e3',
    type: 'tag_team',
    gender: 'male'
  },
  {
    name: 'Mr. Money In The Bank',
    value: 'WWE Speed Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fmitb-mens.png?alt=media&token=891d93ba-e765-4e65-aa9d-d3571a779158',
    type: 'singles',
    gender: 'male',
    isTitle: false
  },
  {
    name: 'Ms. Money In The Bank',
    value: 'WWE Women\'s Speed Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Fmitb-womens.png?alt=media&token=d541ad46-2127-4b57-a336-0f906f85cd22',
    type: 'singles',
    gender: 'female',
    isTitle: false
  },
  // --- TNA ---
  {
    name: 'TNA World Champion',
    value: 'TNA World Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ftna.png?alt=media&token=098a74fa-2c61-4049-9d7a-8bed80db10da',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'TNA Knockouts World Champion',
    value: 'TNA Knockouts World Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ftna-wom.png?alt=media&token=b41acc5a-a746-4cca-9b6f-6ea978037fd5',
    type: 'singles',
    gender: 'female'
  },
  {
    name: 'TNA X Division Champion',
    value: 'TNA X Division Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ftna-x.png?alt=media&token=05911ea7-9fad-47a0-8631-86a35dd34869',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'TNA International Champion',
    value: 'TNA International Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ftna-inter.png?alt=media&token=17270eff-a72f-4b0d-8824-bad9eb02f91e',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'TNA World Tag Team Champion',
    value: 'TNA World Tag Team Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ftna-tag.png?alt=media&token=736c03b1-0ee4-4f8b-9f6d-ed9faebcf714',
    type: 'tag_team',
    gender: 'male'
  },
  {
    name: 'TNA Knockouts World Tag Team Champion',
    value: 'TNA Knockouts World Tag Team Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Ftna-wom-tag.png?alt=media&token=a080b7fb-fe26-4cff-92a9-b8bba04d9c2c',
    type: 'tag_team',
    gender: 'female'
  },
  // --- AAA ---
  {
    name: 'AAA Mega Champion',
    value: 'AAA Mega Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-mega.png?alt=media&token=9177658a-97be-4a36-be2c-5b7b598ce202',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'AAA Reina de Reinas Champion',
    value: 'AAA Reina de Reinas Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-rdr.png?alt=media&token=ae198bdb-cc63-4e1f-b464-13931c632f60',
    type: 'singles',
    gender: 'female'
  },
  {
    name: 'AAA Latin American Champion',
    value: 'AAA Latin American Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-lat-ame.png?alt=media&token=255f72fb-28ad-4930-8a8a-d952122f63d9',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'AAA World Cruiserweight Champion',
    value: 'AAA World Cruiserweight Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-cruis.png?alt=media&token=f62ef880-bb18-42a7-b8fc-9640bbe973dc',
    type: 'singles',
    gender: 'male'
  },
  {
    name: 'AAA World Tag Team Champion',
    value: 'AAA World Tag Team Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-tag.png?alt=media&token=abab83ff-5342-4b71-a807-cd8e298c77a4',
    type: 'tag_team',
    gender: 'male'
  },
  {
    name: 'AAA World Mixed Tag Team Champion',
    value: 'AAA World Mixed Tag Team Champion',
    imageMale: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-mtag.png?alt=media&token=54e80309-bb99-43ad-8719-45bc2ab61a90',
    imageFemale: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-wtag.png?alt=media&token=e93d54b9-7d9a-4f59-b120-9b448d04d59d',
    type: 'mixed_tag_team',
    gender: 'mixed'
  },
  {
    name: 'AAA World Trios Champion',
    value: 'AAA World Trios Champion',
    image: 'https://firebasestorage.googleapis.com/v0/b/fantawwe-83b60.firebasestorage.app/o/titles%2Faaa-trios.png?alt=media&token=c9c16275-2daf-4a20-adb6-620abed98a06',
    type: 'trios',
    gender: 'male'
  }
];

export default CHAMPIONSHIPS;